// subscribeNotificationChannel.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Subscribe notification channel
 * @kind action
 * @param {[string]} {configIds} - array of all config ids.
 * @return {Promise} Action promise.
 */
const subscribeNotificationChannel =
  ({ configIds = [] }) =>
  async dispatch => {
    configIds.forEach(configId => {
      sendMessageToSW({
        type: MessageTypes.SUBSCRIBE_NOTIFICATION_CHANNEL,
        payload: {
          configId,
        },
      });
    });
    return dispatch({ type: '' });
  };

export default subscribeNotificationChannel;
